export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";